import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/workflows_analytics_event.py
export const WORKFLOWS_ANALYTICS_ACTIONS = {
  // ARCHIVE actions
  ARCHIVED_TASK_GROUPS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'archived_task_groups',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_TASKS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'archived_tasks',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_OUTPUTS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'archived_outputs',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ARCHIVED_WORKFLOW_SCHEMAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'archived_workflow_schemas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // CREATE actions
  CREATED_TASK_GROUP: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_task_group',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_TASK: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_TASK_SCHEMA_FIELD: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_task_schema_field',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_OUTPUT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_output',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // UPDATE actions
  UPDATED_CREATION_FOLDER: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_creation_folder',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_GROUP_NAME: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_group_name',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_GROUP_WATCHERS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_group_watchers',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_STATUS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_status',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // TODO (BNCH-65230): Deprecate UPDATED_TASK_EXECUTION_FLOWCHART event in favor of CREATED_OR_UPDATED_FLOWCHART
  UPDATED_TASK_EXECUTION_FLOWCHART: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_execution_flowchart',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // TODO (BNCH-54072): Consolidate UPDATE_TASK analytics events
  UPDATED_TASK_ASSIGNEE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_assignee',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_RESPONSIBLE_PARTIES: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_responsible_parties',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_SCHEDULED_DATE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_scheduled_date',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_SCHEMA_FIELD: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_schema_field',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_OUTPUT_SCHEMA_FIELD: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_output_schema_field',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_OUTPUT_TASK_FIELD: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_output_task_field',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // EXECUTE actions
  EXECUTED_TASK_INTO_ENTRY: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'executed_task_into_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BULK_UNDID_TASK_EXECUTION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'bulk_undid_task_execution',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UNDID_TASK_EXECUTION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'undid_task_execution',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_EXECUTION_ENTRY_NAME: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_execution_entry_name',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_EXECUTION_ENTRY_DATE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_execution_entry_date',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_EXECUTION_ENTRY_FOLDER: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_execution_entry_folder',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  LOADED_TASKS_INTO_EXECUTION_ENTRY: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'loaded_tasks_into_execution_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EXECUTED_TASK_INTO_WORKSHEET: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'executed_task_into_worksheet',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXECUTED_TASK_INTO_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'executed_task_into_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  LOADED_TASKS_INTO_EXECUTION_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'loaded_tasks_into_execution_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  BULK_COMPLETED_TASKS_MODAL_EXECUTION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'bulk_completed_tasks_modal_execution',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_TASK_MODAL_EXECUTION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'completed_task_modal_execution',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // TASK FINDER actions
  RAN_TASK_FINDER: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'ran_task_finder',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RAN_TASK_FINDER_MULTIPLE_FOUND: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'ran_task_finder_multiple_found',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RAN_TASK_FINDER_NONE_FOUND: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'ran_task_finder_none_found',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RAN_TASK_FINDER_ERROR: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'ran_task_finder_error',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // FLOWCHART AUTOMATION actions
  FAILED_AUTOMATED_MAPPING: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'failed_automated_mapping',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CORRECTED_FAILED_AUTOMATED_MAPPING: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'corrected_failed_automated_mapping',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // FLOWCHART actions
  ADJUSTED_CANVAS_WORKSPACE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'adjusted_canvas_workspace',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_FLOWCHART_GRAPH_NODE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_flowchart_graph_node',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TOGGLED_SHOW_NODES_WITHOUT_DATA_IN_FLOWCHART_LINEAGE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'toggle_show_nodes_without_data_in_flowchart_lineage',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // FLOWCHART CONFIGURATION actions
  CLICKED_FLOWCHART_CONFIG_TAB: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_flowchart_config_tab',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_FLOWCHART_CONFIG_EDITOR: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'closed_flowchart_config_editor',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_FLOWCHART_CONFIG_EDITOR: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'opened_flowchart_config_editor',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_FLOWCHART_WITH_CHAINED_ROUTERS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'opened_flowchart_with_chained_routers',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_FLOWCHART_CONFIG_EDITOR: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'submitted_flowchart_config_editor',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  WARNING_CLOSED_FLOWCHART_CONFIG_ITEM_DELETION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'warning_closed_flowchart_config_item_deletion',
    actionCategory: ACTION_CATEGORY.READ,
  },
  WARNING_OVERRIDDEN_FLOWCHART_CONFIG_ITEM_DELETION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'warning_overridden_flowchart_config_item_deletion',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  WARNING_SHOWN_FLOWCHART_CONFIG_ITEM_DELETION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'warning_shown_flowchart_config_item_deletion',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODIFIED_ITEM_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'modified_item_in_canvas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // ROUTER CONFIGURATION actions
  CREATED_ROUTER_CONFIGURATION_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_router_configuration_in_canvas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DELETED_ROUTER_CONFIGURATION_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'deleted_router_configuration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_ROUTER_CONFIGURATION_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_router_configuration',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_ROUTER_CONFIGURATION_IN_DB: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_router_configuration_in_db',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_ROUTER_RULE_IN_DB: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_router_rule_in_db',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ERROR_MESSAGE_SHOWN_ROUTER_CONFIGURATION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'error_message_shown_router_configuration',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // FLOWCHART FIRST CONFIGURATION actions
  TRANSITION_SOURCE_CHANGED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'transition_source_changed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLEX_LOOKUP_MADE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'complex_lookup_made',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NODE_ADDED_FROM_LEFT_SIDEPANEL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'node_added_from_left_sidepanel',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  NODE_ADDED_FROM_RIGHT_HANDLE_CLICK: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'node_added_from_right_handle_click',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDGE_DRAWN: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'edge_drawn',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DATA_FLOW_EDGE_ADDED_VIA_MIRRORING: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'data_flow_edge_added_via_mirroring',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  DATA_FLOW_EDGE_REMOVED_VIA_MIRRORING: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'data_flow_edge_removed_via_mirroring',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_NEW_TASK_DEFINITION_FROM_FLOWCHART: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_new_task_definition_from_flowchart',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  EDITED_TASK_NODE_DEFINITION_FROM_FLOWCHART: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'edited_task_node_definition_from_flowchart',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_HORIZONTAL_FLOWCHART_EDITOR: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'opened_horizontal_flowchart_editor',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_FLOWCHART: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_flowchart',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_AUTOLAYOUT_BUTTON: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_autolayout_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_NODE_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'selected_node_in_canvas',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIDEPANEL_VISIBILITY_STATE_CHANGED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'sidepanel_visibility_state_changed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DELETED_EDGES_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'deleted_edges_in_canvas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_FLOWCHART_SETTINGS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_flowchart_settings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MULTI_SELECTED_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'multi_selected_in_canvas',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SEARCHED_TASK_SCHEMAS_IN_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'searched_task_schemas_in_canvas',
    actionCategory: ACTION_CATEGORY.READ,
  },
  NODE_REMOVED_FROM_CANVAS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'node_removed_from_canvas',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SINGLE_FLOWCHART_TRANSITION_MODAL_OPENED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'single_flowchart_transition_modal_opened',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPTIONAL_TRANSITION_CREATED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'optional_transition_created',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPTIONAL_TRANSITION_EDITED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'optional_transition_edited',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPTIONAL_TRANSITION_DELETED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'optional_transition_deleted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPTIONAL_TRANSITION_PROMOTED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'optional_transition_promoted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPTIONAL_TRANSITION_PROMOTION_CANCELLED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'optional_transition_promotion_cancelled',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MERGE_TRANSITION_MODAL_CANCELLED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'merge_transition_modal_cancelled',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MERGE_TRANSITION_CREATED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'merge_transition_created',
    actionCategory: ACTION_CATEGORY.WRITE,
  },

  // ACM/PCM EDITOR actions
  ACM_EDITOR_CHANGES_SAVED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'acm_editor_changes_saved',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  PCM_EDITOR_CHANGES_SAVED: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'pcm_editor_changes_saved',
    actionCategory: ACTION_CATEGORY.WRITE,
  },

  // SCHEMA CONFIGURATION actions
  CREATED_TASK_SCHEMA: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_task_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_TASK_SCHEMA: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'updated_task_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // MISC actions
  ADJUSTED_VIEW_TASK_GROUP_INSTRUCTIONS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'adjusted_view_task_group_instructions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_EXECUTION_ENTRY_CHIP: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_execution_entry_chip',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_TASK_OR_OUTPUT_CHIP: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_task_or_output_chip',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_TABLE_EXPAND: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_table_expand',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_TABLE_COLLAPSE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_table_collapse',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_TASK_TABLE_EDIT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_task_table_edit',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_OUTPUT_TABLE_EDIT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_output_table_edit',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_TASK_TABLE_SUBMIT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_task_table_submit',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_NEXT_TASK_GROUP_BUTTON: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_next_task_group_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_OUTPUT_TABLE_SUBMIT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_output_table_submit',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_RELEVANT_ITEM: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_relevant_item',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLONED_TASK: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'cloned_task',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLONED_TASK_SCHEMA: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'cloned_task_schema',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_WORKFLOW_DASHBOARD: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'opened_workflow_dashboard',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_DASHBOARD_CONTEXT_MENU_FILTER: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'clicked_dashboard_context_menu_filter',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_TASK_GROUP_DETAILS: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'opened_task_group_details',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SENT_NOTIFICATION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'sent_notification',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RESET_ENTRY_VERSION_ATTEMPT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'reset_entry_version_attempt',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OVERRODE_DEFAULT_STATUS_OUTPUT_CREATION_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'overrode_default_status_output_creation_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_DEFAULT_STATUS_OUTPUT_CREATION_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'submitted_default_status_output_creation_modal',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_OUTPUT_TERMINAL_TASK_ATTEMPT: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_output_terminal_task_attempt',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_TASK_FROM_CALENDAR_ITEM_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'opened_task_from_calendar_item_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_FLOWCHART_NODE_IN_DATABASE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_flowchart_node_in_database',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_OR_UPDATED_FLOWCHART: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'created_or_updated_flowchart',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ADJUSTED_VIEW_TASK_CREATION: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'adjusted_view_task_creation',
    actionCategory: ACTION_CATEGORY.READ,
  },
  HID_FLOWCHART_PANE_IN_TASK_GROUP_CREATION_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'hid_flowchart_pane_in_task_group_creation_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  EXPANDED_FLOWCHART_PANE_IN_TASK_GROUP_CREATION_MODAL: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'expanded_flowchart_pane_in_task_group_creation_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  FAILED_COLUMN_MAPPING_TO_TASK_TABLE: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'failed_column_mapping_to_task_table',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  TRIGGERED_FLOWCHART_VALIDATION_ERROR: {
    module: ANALYTICS_MODULE.WORKFLOWS,
    action: 'triggered_flowchart_validation_error',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};

// Modal Types
export const CREATE_PROCESS_MODAL_TYPE = 'create_process_modal';
export const UPDATE_FLOWCHART_MODAL_TYPE = 'update_flowchart_modal';
